var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.186,
    height: 42.186,
    viewBox: "0 0 1437 1437",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil1{fill:#fefefe}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 718,
    cy: 718,
    r: 718,
    fill: "#201e1e"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M888 693H743v-49h-49v97h194v49H743v48h48v49h-48v-49h-49v49h49v48h48v97h243V790h-97v-48h-49v-49h49v48h97v-48h-97v-49h97V401H791v243h97v49zm-57 148h160v146H831V841zm3-392h160v146H834V449zM646 741v-48H403v48h97v49h-48v48h47v49h-47v-49h-49v97h49v49h48v48h243v-48h-49v-49h-48v49h-97v-49h48v-48h-45V751h45v136h49v-97h48v-49h-48zM403 984v48h49v-48h-49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M403 644h243V498h48v-48h-48v-49H403v243zm40-194h161v146H443V450zm300 0v-49h-49v49h49zm-49 146h49v-98h-49v98zM886 494h53.646v53.646H886z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M496 498h53.646v53.646H496zM885 887h53.646v53.646H885z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginQrCode);
export default __webpack_public_path__ + "static/media/login-qr-code.2ed60220427e096227feea8b37fd2f8b.svg";
export { ForwardRef as ReactComponent };